import React from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";

const CurriculumCard = ({
  curriculum,
  onClick,
  showActions = false,
  onEdit,
  onDelete,
}) => {
  const handleDeleteClick = (e) => {
    e.stopPropagation();

    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmToast
          title="Are you sure?"
          message="You want to delete this curriculum?"
          onClose={onClose}
          onSuccess={() => {
            onDelete(curriculum);
            onClose();
          }}
        />
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "!bg-gray-500 !bg-opacity-75",
    });
  };

  return (
    <div
      className="relative bg-black rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 cursor-pointer"
      onClick={() => onClick && onClick(curriculum)}
    >
      {/* TOP RIGHT – EDIT */}
      {showActions && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(curriculum);
          }}
          className="absolute -top-2 -right-2 w-9 h-9 flex items-center justify-center 
                     rounded-full bg-white/10 hover:bg-white/20 transition"
        >
          <FiEdit2 size={16} className="text-white" />
        </button>
      )}

      <div className="flex justify-between items-start mb-4">
        <h3 className="text-xl font-semibold text-gray-400 truncate">
          {curriculum.curriculum_name}
        </h3>

        <span
          className={`px-2 py-1 text-xs rounded-full ${
            curriculum.publish === "true"
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
          }`}
        >
          {curriculum.publish === "true" ? "Published" : "Draft"}
        </span>
      </div>

      <p className="text-gray-400 line-clamp-3 mb-10">
        {curriculum.curriculum_description}
      </p>

      {/* BOTTOM RIGHT – DELETE */}
      {showActions && (
        <button
          onClick={handleDeleteClick}
          className="absolute -bottom-2 -right-2 w-9 h-9 flex items-center justify-center 
                     rounded-full bg-white/10 hover:bg-red-500/30 transition"
        >
          <FiTrash2 size={16} className="text-white" />
        </button>
      )}
    </div>
  );
};

export default CurriculumCard;
